import React, { FC, memo } from "react";
import { useTranslation } from "react-i18next";
import {
  BooksHeaderLink,
  BooksHeaderWrapper,
} from "../../Books/components/BooksHeader/BooksHeader.styles";

const ToolsHeader: FC = () => {
  const { t } = useTranslation("common");
  return (
    <BooksHeaderWrapper>
      <BooksHeaderLink title={t("tools.putAway")} end to="/tools">
        {t("tools.putAway")}
      </BooksHeaderLink>
      <BooksHeaderLink
        title={t("tools.printUsers")}
        end
        to="/tools/print-users"
      >
        {t("tools.printUsers")}
      </BooksHeaderLink>
    </BooksHeaderWrapper>
  );
};

export default memo(ToolsHeader);
